import Table from "../components/notice/Table";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/* 
通知マスタ一覧
 */
const Notice = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.MASTER_EDIT);
  return (
    <SpaceBetween size="l">
      <Table />
    </SpaceBetween>
  );
};

export default Notice;
